export const getDet = (matrix) => {
  const a11 = matrix.a;
  const a12 = matrix.c;
  const a13 = matrix.e;
  const a21 = matrix.b;
  const a22 = matrix.d;
  const a23 = matrix.f;
  const a31 = 0;
  const a32 = 0;
  const a33 = 1;
  return (
    a11 * a22 * a33 +
    a12 * a23 * a31 +
    a13 * a21 * a32 -
    (a11 * a23 * a32 + a12 * a21 * a33 + a13 * a22 * a31)
  );
};
